{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Vlastní atributy",
    "HEADER_BTN_TXT": "Přidat vlastní atribut",
    "LOADING": "Načítání vlastních atributů",
    "DESCRIPTION": "Vlastní atribut sleduje dodatečné informace o vašich kontaktech nebo konverzacích - například typ předpatného nebo datum prvního nákupu. Můžete přidat různé typy vlastních atributů, jako je text, seznamy nebo čísla, abyste zachytili konkrétní informace, které potřebujete.",
    "LEARN_MORE": "Více o vlastních atributech",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Text",
      "NUMBER": "Číslo",
      "LINK": "Odkaz",
      "DATE": "Datum",
      "LIST": "Seznam",
      "CHECKBOX": "Zaškrtávací pole",
      "TEXT_AREA": "Víceřádkový text"
    },
    "ADD": {
      "TITLE": "Přidat vlastní atribut",
      "SUBMIT": "Vytvořit",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "NAME": {
          "LABEL": "Zobrazovaný název",
          "PLACEHOLDER": "Zadejte zobrazovaný název vlastního atributu",
          "ERROR": "Název je povinný"
        },
        "DESC": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadejte popis vlastního atributu",
          "ERROR": "Popis je povinný"
        },
        "MODEL": {
          "LABEL": "Platí pro",
          "PLACEHOLDER": "Prosím vyberte jednu možnost",
          "ERROR": "Model je povinný"
        },
        "TYPE": {
          "LABEL": "Typ",
          "PLACEHOLDER": "Prosím vyberte typ",
          "ERROR": "Typ je povinný",
          "LIST": {
            "LABEL": "Hodnoty seznamu",
            "PLACEHOLDER": "Zadejte hodnotu a stiskněte klávesu enter",
            "ERROR": "Musí obsahovat alespoň jednu hodnotu"
          }
        },
        "KEY": {
          "LABEL": "Klíč",
          "PLACEHOLDER": "Zadejte klíč vlastního atributu",
          "ERROR": "Klíč je povinný",
          "IN_VALID": "Neplatný klíč"
        },
        "REGEX_PATTERN": {
          "LABEL": "Vzor regulárního výrazu (regex)",
          "PLACEHOLDER": "Zadejte vzor regulárního výrazu vlastního atributu. (Volitelné)"
        },
        "REGEX_CUE": {
          "LABEL": "Nápověda regulárního výrazu (regex)",
          "PLACEHOLDER": "Zadejte nápovědu pro vzor regulárního výrazu. (Volitelné)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Povolit validaci regulárním výrazem"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Vlastní atribut úspěšně přidán!",
        "ERROR_MESSAGE": "Nelze vytvořit vlastní atribut. Zkuste to prosím později."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Vlastní atribut úspěšně smazán.",
        "ERROR_MESSAGE": "Nelze smazat vlastní atribut. Zkuste to znovu."
      },
      "CONFIRM": {
        "TITLE": "Opravdu chcete smazat - {attributeName}",
        "PLACE_HOLDER": "Pro potvrzení napište {attributeName}",
        "MESSAGE": "Smazáním odstraníte vlastní atribut",
        "YES": "Vymazat ",
        "NO": "Zrušit"
      }
    },
    "EDIT": {
      "TITLE": "Upravit vlastní atribut",
      "UPDATE_BUTTON_TEXT": "Aktualizovat",
      "TYPE": {
        "LIST": {
          "LABEL": "Hodnoty seznamu",
          "PLACEHOLDER": "Zadejte hodnoty a stiskněte klávesu enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Vlastní atribut úspěšně aktualizován",
        "ERROR_MESSAGE": "Při aktualizaci vlastního atributu došlo k chybě, zkuste to prosím znovu"
      }
    },
    "TABS": {
      "HEADER": "Vlastní atributy",
      "CONVERSATION": "Konverzace",
      "CONTACT": "Kontakt"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Název",
        "DESCRIPTION": "Popis",
        "TYPE": "Typ",
        "KEY": "Klíč"
      },
      "BUTTONS": {
        "EDIT": "Upravit",
        "DELETE": "Vymazat"
      },
      "EMPTY_RESULT": {
        "404": "Nejsou vytvořeny žádné vlastní atributy",
        "NOT_FOUND": "Nejsou nakonfigurovány žádné vlastní atributy"
      },
      "REGEX_PATTERN": {
        "LABEL": "Vzor regulárního výrazu",
        "PLACEHOLDER": "Zadejte vzor regulárního výrazu vlastního atributu. (Volitelné)"
      },
      "REGEX_CUE": {
        "LABEL": "Nápověda regulárního výrazu",
        "PLACEHOLDER": "Zadejte nápovědu pro vzor regulárního výrazu. (Volitelné)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Povolit validaci regulárním výrazem"
      }
    }
  }
}
